<div class="list-wrapper" [class.loading]="isLoading">
  <!-- Mail list header -->
  <div class="header">
    <!-- Header left -->
    <div class="left">
      <!-- Sidebar toggle button -->
      <button class="sidebar-toggle" mat-icon-button (click)="projectsListComponent.drawer.toggle()">
        <mat-icon [svgIcon]="'menu'"></mat-icon>
      </button>
      <!-- Category name -->
      <div class="category">{{ pipeline.name }}</div>
      <ng-container *ngIf="propertyTypes?.length > 0">
        <button class="toggle-labels" mat-icon-button [matMenuTriggerFor]="toggleLabelMenu">
          <mat-icon [svgIcon]="'color_lens'"></mat-icon>
        </button>
        <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
          <div mat-menu-item *ngFor="let propertyType of propertyTypes; trackBy: trackByFn">
            <mat-icon [ngClass]="'text-' + propertyType.color + '-500'" [svgIcon]="'color_lens'"></mat-icon>
            {{ propertyType.name }}
          </div>
        </mat-menu>
      </ng-container>
    </div>
    <div class="main-actions">
      <project-list-header [pipeline]="pipeline"></project-list-header>

      <div class="projects-list-filter">
        <list-filter
          (projectFilters)="filterProjects($event)"
          [queryFilters]="queryFilters"
          [savedFilter]="savedFilter"
          [hideSaveButton]="hideSaveButton()"
          [hideFilterName]="isDynamicPipeline"
          [allowRelatedObjectFields]="hasNestedFiltersOn"
        ></list-filter>
      </div>
      <!-- Add contact button -->
      <input style="display: none" type="file" (change)="onProjectFileChanged($event)" #projectFileInput />

      <button
        class="add-contact ml-2"
        [matMenuTriggerFor]="addProjectMenu"
        mat-flat-button
        [color]="'primary'"
        [appAuthorize]="canAddDeal"
        denyAction="disable"
        [disabled]="pipeline.pipeline_type === 'dynamic'"
      >
        <ng-container *ngIf="!uploadingFile">
          <mat-icon [svgIcon]="'keyboard_arrow_down'"></mat-icon> Add
        </ng-container>
        <mat-progress-spinner *ngIf="uploadingFile" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>
      <mat-menu #addProjectMenu="matMenu">
        <button id="create-project" mat-menu-item (click)="openCustomDrawer()">
          <span class="ml-2"> <mat-icon svgIcon="add"></mat-icon> Enter Details </span>
        </button>
        <button mat-menu-item (click)="createProject()">
          <span class="ml-2"> <mat-icon [svgIcon]="'add'"></mat-icon> By Url </span>
        </button>
        <button mat-menu-item (click)="projectFileInput.click()">
          <span class="ml-2"> <mat-icon [svgIcon]="'publish'"></mat-icon> Upload OM </span>
        </button>
        <button mat-menu-item (click)="navigateToProjectsAddMap()">
          <span class="ml-2"> <mat-icon [svgIcon]="'language'"></mat-icon> Select On Map </span>
        </button>
      </mat-menu>
      <button appAuthorize="PIPELINE_MANAGE" class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="editLayout()">
          <mat-icon svgIcon="file_copy"></mat-icon>
          Edit Layout
        </button>
      </mat-menu>
    </div>
    <div class="loader" *ngIf="isLoading">
      <mat-progress-bar class="loading-progress-bar" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
  <div class="projects-list">
    <div class="table-wrapper">
      <div class="inline-table-wrapper">
        <div class="kanban-container" cdkDropListGroup #lists>
          <div
            [ngClass]="{
              'kanban-group': true,
              'no-data': groupedProjects[getGroupUniqueKey(group)]?.length === 0 || group.collapse,
            }"
            [id]="group.id"
            *ngFor="let group of lanes"
            (cdkDropListDropped)="dropped($event)"
            [cdkDropListEnterPredicate]="canDrop(group)"
            cdkDropList
            [cdkDropListData]="groupedProjects[getGroupUniqueKey(group)]"
            cdkDragBoundary=".kanban-container"
          >
            <ng-container *ngIf="getGroupUniqueKey(group) as groupUniqueKey">
              <div class="kanban-header">
                <div class="kanban-item-title">
                  <ts-icon
                    *ngIf="group.hidden"
                    class="mr-2"
                    icon="ts_eye"
                    iconColor="gray"
                    [matTooltip]="group.name + ' (Hidden)'"
                  ></ts-icon>
                  <span [ngClass]="{ 'text-gray-500': group.hidden }">{{ group.name }}</span>
                  <span
                    class="kanban-item-count"
                    *ngIf="groupedProjects[groupUniqueKey]?.length"
                    [matTooltip]="'Showing ' + groupedProjects[groupUniqueKey]?.length + ' of ' + getLaneCount(group)"
                    matTooltipPosition="right"
                    [ngClass]="{ 'text-gray-500': group.hidden }"
                  >
                    <ng-container *ngIf="isGroupCustom">
                      {{ groupedProjects[groupUniqueKey]?.length }}/{{ getLaneCount(group) }}
                    </ng-container>
                    <ng-container *ngIf="!isGroupCustom">
                      ({{ groupedProjects[groupUniqueKey]?.length }}/{{ getLaneCount(group) }})
                    </ng-container>
                  </span>
                </div>
                <button
                  *ngIf="groupedProjects[groupUniqueKey]?.length"
                  mat-icon-button
                  [matTooltip]="group.collapse ? 'Unfold' : 'Fold'"
                  (click)="collapse(groupUniqueKey, !group.collapse)"
                >
                  <mat-icon class="rotate-90" *ngIf="group.collapse; else fold">unfold_more</mat-icon>
                  <ng-template #fold>
                    <mat-icon>unfold_less</mat-icon>
                  </ng-template>
                </button>
              </div>
              <div
                #lane
                [id]="groupUniqueKey"
                *ngIf="!(groupedProjects[groupUniqueKey]?.length === 0 || group.collapse)"
                class="lane-cards-container"
                (scroll)="onScroll($event, group, groupUniqueKey)"
                (wheel)="onWheel($event, groupUniqueKey)"
              >
                <treo-card
                  class="flex items-center justify-between w-full p-3 filter-info m-0 mb-4 rounded border-l-4 kanban-card"
                  [ngClass]="'border-' + item.property_type?.color + '-500'"
                  *ngFor="let item of groupedProjects[groupUniqueKey]; let j = index"
                  cdkDrag
                  [cdkDragDisabled]="group.hidden || !item.permissions?.is_editable"
                  [cdkDragData]="item"
                >
                  <ng-container *ngIf="item?.id">
                    <div class="flex flex-col full-width">
                      <div class="text-2xl font-semibold leading-tight kanban-card-title">
                        <a [routerLink]="['../' + item.id]">{{ item.title || '-' }}</a>
                      </div>
                      <div class="field-layout">
                        <div class="field-layout__columns">
                          <ng-container *ngFor="let column of columnsAndRows; let x = index">
                            <div class="field-layout__columns__column">
                              <div *ngFor="let row of column; let y = index" class="field-layout__columns__column__row">
                                <ng-container *ngIf="lookupField(row) as fieldDef">
                                  <ng-container *ngIf="isLinkedFieldColumn(fieldDef); else defaultField">
                                    <div class="flex flex-row">
                                      <div class="font-semibold mr-1 text-md">{{ fieldDef.label }}:</div>
                                      <div class="text-md">
                                        <linkable-related-field-cell
                                          [type]="fieldDef?.related_to_type"
                                          [value]="getLinkedFieldValue(item, fieldDef.name)"
                                        ></linkable-related-field-cell>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #defaultField>
                                    <app-inline-field
                                      [fieldDef]="fieldDef"
                                      [model]="item"
                                      [data]="data"
                                    ></app-inline-field>
                                  </ng-template>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="itemAction" class="more-actions">
                      <mat-icon class="text-dark" [svgIcon]="'more_vert'"></mat-icon>
                    </button>
                    <mat-menu #itemAction="matMenu" class="kanban-dropdown-menu">
                      <button mat-menu-item (click)="openProjectDialog(item)" class="py-4">View</button>
                      <button
                        mat-menu-item
                        (click)="changeStatus(item)"
                        class="py-4"
                        [appAuthorize]="[NewPermission.DEALS_EDIT, item.permissions?.is_editable]"
                        denyAction="disable"
                      >
                        Change Status
                      </button>
                      <button
                        mat-menu-item
                        (click)="moveDeal(item)"
                        class="py-4"
                        [appAuthorize]="[NewPermission.DEALS_EDIT, item.permissions?.is_editable]"
                        denyAction="disable"
                      >
                        Move Views
                      </button>
                      <button
                        [appAuthorize]="canDeleteDeal(item)"
                        denyAction="disable"
                        mat-menu-item
                        (click)="deleteProject(item)"
                        class="py-4"
                      >
                        Delete
                      </button>
                    </mat-menu>
                    <img
                      class="w-16 h-16 ml-2 rounded-full"
                      [src]="item?.featured_image_url"
                      onerror="this.onerror=null;this.src='https://termsheet-cdn.s3.amazonaws.com/placeholder.jpg';"
                      alt="item.title"
                    />
                    <img
                      *cdkDragPreview
                      [src]="item?.featured_image_url"
                      id="kanban-preview"
                      onerror="this.onerror=null;this.src='https://termsheet-cdn.s3.amazonaws.com/placeholder.jpg';"
                      [alt]="item.title"
                    />
                    <div id="kanban-placeholder" *cdkDragPlaceholder></div>
                  </ng-container>
                </treo-card>
                <ng-container *ngIf="isLoadingLaneKeys.includes(groupUniqueKey)">
                  <div class="kanban-group-loader">
                    <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner></div
                ></ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <mat-toolbar>
        <mat-toolbar-row>
          <div class="flex align-center flex-row">
            <mat-form-field class="flex-auto gt-xs:pr-3 group-by-select" *ngIf="canManagePipeline()">
              <mat-label></mat-label>
              <mat-select
                [ngModel]="pipeline.kanban_definition?.groupBy || defaultGroupBy"
                (ngModelChange)="pipeline.kanban_definition?.groupBy || (defaultGroupBy = $event)"
                (selectionChange)="onChangeGroupBy($event)"
              >
                <mat-option *ngFor="let groupByOption of groupByOptions | keyvalue" [value]="groupByOption.key">{{
                  groupByOption.value
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <a mat-icon-button class="ml-1 pt-1" [routerLink]="['/reports']">
              <mat-icon>pie_chart</mat-icon>
            </a>
          </div>
          <span class="example-spacer"></span>
        </mat-toolbar-row>
      </mat-toolbar>
      <ng-template #noProjects>
        <div class="no-products">There are no deals!</div>
      </ng-template>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
